// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedPreview.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Preview component
 */
import React from 'react';
import { observer } from 'mobx-react';
import EventsUtils from 'EventUtils';
import FormGroup from 'share/components/controls/Izenda.FormGroup';
import Label from 'share/components/controls/Izenda.Label';
import DropDown from 'share/components/controls/Izenda.DropDown';
import Input from 'share/components/controls/Izenda.Input';
import constants from 'logic/data/Izenda.CalculatedFieldConstants';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';

@observer
class Preview extends React.Component {
  static displayName = 'Preview';

  /**
   * Handle preview action.
   */
  preview = () => {
    let {
      store,
      validation: valManager,
      reportDesigner,
      reportPart,
      type,
      querySourceId,
      startLoading,
      endLoading,
      updateError
    } = this.props;

    valManager.reset();

    switch (type.name) {
      case constants.TYPES.SUB_TOTAL.name:
      case constants.TYPES.GRAND_TOTAL.name:
        startLoading();
        return store
          .previewReportProperties(reportDesigner, reportPart)
          .then(errors => updateError(errors))
          .finally(endLoading);
      default:
        startLoading();
        return store.preview.bind(store)(querySourceId)
          .then(errors => updateError(errors))
          .finally(endLoading);
    }
  }

  render() {
    let notifyChange = EventsUtils.notifyChange;
    let { localization, store: { clonedModel: model }, type } = this.props;
    const previewResult = ReportPartUtils.applyFormater(
      model.izendaDataType,
      model.format.format,
      model.previewResult
    );
    const disablePreview =
      (type.name !== constants.TYPES.SUB_TOTAL.name &&
        type.name !== constants.TYPES.GRAND_TOTAL.name) ||
      model.functionName === constants.FUNCTION_NAME.EXPRESSION
        ? model.disablePreview
        : model.functionName === constants.FUNCTION_NAME.NONE;

    return (
      <FormGroup className="u_paddingRight">
        <Label className="col-md-3 text-left u_paddingLeft">
          {localization.getText('COMMON_LABEL_PREVIEW_RESULT')}
        </Label>
        <div className="col-md-9 u_noPaddingAll flex-layout">
          <Input
            title={previewResult}
            value={previewResult}
            className="form-control u-bgGray"
            readOnly
          />
          <button
            className="btn btn-primary previewBtn"
            disabled={disablePreview}
            onClick={this.preview}>
            Preview
          </button>
        </div>
      </FormGroup>
    );
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./ui/share/components/controls/calculatedField/Izenda.CalculatedPreview.js